/* The contents of this file are generated automatically during the build process of this component.
 * If you need to make changes on these styles, go to the .scss files of this repository.
 * Once you are done, run the "npm run build" script to update this file and commit your changes, including this file.
*/

import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
`<template>
<style>
/*CSS-START*/
:host {
  /* RA variable names */
  /* Primary colors */
  --primary: var(--primary-theme);
  --primary-dark: var(--primary-dark-theme);
  --primary-background: var(--primary-background-theme);
  --primary-other: var(--primary-other-theme);
  --primary-disabled: var(--primary-disabled-theme);
  --primary-message: var(--primary-message-theme);
  --primary-alert: var(--primary-alert-theme);
  --primary-gradient-from: var(--primary-gradient-from-theme);
  --primary-gradient-to: var(--primary-gradient-to-theme);
  /* Secondary colors */
  --secondary-focus: var(--secondary-focus-theme);
  --secondary-hover: var(--secondary-hover-theme);
  --secondary-disabled: var(--secondary-disabled-theme);
  --secondary-background: var(--secondary-background-theme);
  --secondary-other-dark: var(--secondary-other-dark-theme);
  --secondary-other-hover: var(--secondary-other-hover-theme);
  --secondary-other-disabled: var(--secondary-other-disabled-theme);
  --secondary-other-good-to-go: var(--secondary-other-good-to-go-theme);
  --secondary-message: var(--secondary-message-theme);
  --secondary-message-detail: var(--secondary-message-detail-theme);
  --secondary-message-chrome: var(--secondary-message-chrome-theme);
  --secondary-gradient-from: var(--secondary-gradient-from-theme);
  --secondary-gradient-to: var(--secondary-gradient-to-theme);
  --secondary-inactive: var(--secondary-inactive-theme);
  /* Other colors */
  --reversed-hover: var(--reversed-hover-theme);
  --link: var(--link-theme);
  --outline-color: var(--outline-color-theme);
  --outline-style: var(--outline-style-theme);
  --outline-width: var(--outline-width-theme);
}

.primary {
  color: var(--primary);
}
.primary:hover {
  color: var(--secondary-hover);
}
.primary[disabled] {
  color: var(--secondary-disabled);
  cursor: not-allowed;
  -ms-user-select: none;
  user-select: none;
}

.primary-dark {
  color: var(--primary-dark);
}

.primary-other {
  color: var(--primary-other);
}

.primary-message {
  color: var(--primary-message);
}

.primary-alert {
  color: var(--primary-alert);
}

.background-primary-background {
  background-color: var(--primary-background);
}

.background-primary {
  background-color: var(--primary);
}

.background-primary-dark {
  background-color: var(--primary-dark);
}

.background-primary-other {
  background-color: var(--primary-other);
}

.background-primary-message {
  background-color: var(--primary-message);
}

.background-primary-alert {
  background-color: var(--primary-alert);
}

.background-primary-gradient {
  background: linear-gradient(45deg, var(--primary-gradient-from), var(--primary-gradient-to));
}

.secondary-other-dark {
  color: var(--secondary-other-dark);
}
.secondary-other-dark:hover {
  color: var(--secondary-other-hover);
}
.secondary-other-dark[disabled] {
  color: var(--secondary-other-disabled);
  cursor: not-allowed;
  -ms-user-select: none;
  user-select: none;
}

.secondary-other-good-to-go {
  color: var(--secondary-other-good-to-go);
}

.secondary-message {
  color: var(--secondary-message);
}

.secondary-message-detail {
  color: var(--secondary-message-detail);
}

.secondary-message-chrome {
  color: var(--secondary-message-chrome);
}

.background-secondary {
  background-color: var(--secondary-background);
}

.background-secondary-focus {
  background-color: var(--secondary-focus);
}

.background-secondary-hover {
  background-color: var(--secondary-hover);
}

.background-secondary-disabled {
  background-color: var(--secondary-disabled);
}

.background-secondary-other-hover {
  background-color: var(--secondary-other-hover);
}

.background-secondary-other-disabled {
  background-color: var(--secondary-other-disabled);
}

.background-secondary-other-dark {
  background-color: var(--secondary-other-dark);
}

.background-secondary-other-good-to-go {
  background-color: var(--secondary-other-good-to-go);
}

.background-secondary-message {
  background-color: var(--secondary-message);
}

.background-secondary-inactive {
  background-color: var(--secondary-inactive);
}

.background-secondary-message-detail {
  background-color: var(--secondary-message-detail);
}

.background-secondary-message-chrome {
  background-color: var(--secondary-message-chrome);
}

.background-secondary-gradient {
  background: linear-gradient(45deg, var(--secondary-gradient-from), var(--secondary-gradient-to));
}

a,
.link {
  color: var(--link);
  text-decoration: none;
}
a:link, a:visited, a:hover, a:active,
.link:link,
.link:visited,
.link:hover,
.link:active {
  color: var(--link);
}
a:hover, a:focus,
.link:hover,
.link:focus {
  text-decoration: underline;
}

.link {
  color: var(--link);
  cursor: pointer;
}

a:focus,
.link:focus,
button:focus {
  outline-color: var(--outline-color);
  outline-style: var(--outline-style);
  outline-width: var(--outline-width);
}/*CSS-END*/
</style>
</template>`;

styleElement.register('wdpr-color');
